export default __webpack_public_path__ + "static/ap-0d453b8857fb36cb4df33a5a441c13d8.png";